import { render } from "./DeleteAllLocations.vue?vue&type=template&id=01b1be96"
import script from "./DeleteAllLocations.vue?vue&type=script&lang=js"
export * from "./DeleteAllLocations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__